import request from '@core/services/request';

export const addressAPI = {
	findZipCode: (fiMenuAddress: any) => request.post(`/USPS/FindZIPCode`, { address: fiMenuAddress }),
	zipToCounty: (zipCode: any) => request.get(`/TIGERWeb/ZIPToCounty?zipCode=${zipCode}`),
};
